import { Dispatch } from "redux";
import {
    deleteAccessoryFailure,
    deleteAccessoryRequest,
    deleteAccessorySuccess,
    getAccessoriesFailure,
    getAccessoriesRequest,
    getAccessoriesSuccess,
    postAccessoryFailure,
    postAccessoryRequest,
    postAccessorySuccess,
} from "src/store/actions/accessories";
import { ActionType } from "src/store/dataService/actions/utils/actionCreator";
import { deleteTo, getFromAuthed, postTo } from "./shared/osfetch";
import { findRoute } from "./util";

const getAccessories = async (
    next: Dispatch,
    { payload: { uuid, vin, paymentType, afterFetch } }: ActionType<typeof getAccessoriesRequest>
) => {
    const response = await getFromAuthed(`/deals/${uuid}/accessories/vehicle/${vin}`);

    if (response.ok) {
        next(getAccessoriesSuccess(vin, paymentType, await response.json()));
    } else {
        next(getAccessoriesFailure(vin));
    }

    if (afterFetch) {
        afterFetch();
    }
};

const postAccessory = async (
    next: Dispatch,
    { payload: { uuid, vin, accessoryId } }: ActionType<typeof postAccessoryRequest>
) => {
    const response = await postTo(`/deals/${uuid}/accessories/vehicle/${vin}/accessory/${accessoryId}`, {}, next);

    if (response.ok) {
        next(postAccessorySuccess(vin, accessoryId));
        return;
    }

    next(postAccessoryFailure(vin, accessoryId));
};

const deleteAccessory = async (
    next: Dispatch,
    { payload: { vin, uuid, accessoryId } }: ActionType<typeof deleteAccessoryRequest>
) => {
    const response = await deleteTo(`/deals/${uuid}/accessories/vehicle/${vin}/accessory/${accessoryId}`, {}, next);

    if (response.ok) {
        next(deleteAccessorySuccess(vin, accessoryId));
        return;
    }

    next(deleteAccessoryFailure(vin, accessoryId));
};

const routes = {
    [getAccessoriesRequest.type]: getAccessories,
    [postAccessoryRequest.type]: postAccessory,
    [deleteAccessoryRequest.type]: deleteAccessory,
};

export default (next: Dispatch, action: any) => findRoute(routes)(next, action);
